import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import React, { useMemo } from 'react'
import ExperienceSearchList from '../ExperienceLists/ExperienceSearchList'
import ExperienceDenseSearchList from '../ExperienceLists/ExperienceDenseSearchList'
import { pluralizeToString } from 'lib/string/pluralize'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import useExperiencesSortOptions from '../hooks/useExperiencesSortOptions'
import Group from 'components/utils/Group'
import useExperiencesSearchFilters from '../hooks/useExperiencesSearchFilters'
import { OfferListEventsProvider } from 'components/OfferList/OfferListEventsContext'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'
import { getListName } from 'analytics/enhanced-ecommerce'

const Loader = styled(LoadingIndicator)`
  padding: 0;
`

interface Props {
  list: App.ApiCallState<{
    ids: Array<string>
    placeId: string
  }>
  destinationName: string
  sortBy?: Experiences.SortTypes
  excludeIds?: Array<string>
  isCompactTilesEnabled: boolean
}

function ExperienceSearchPageList(props: Props) {
  const { sortBy } = useExperiencesSortOptions()
  const { list, excludeIds, isCompactTilesEnabled } = props
  const fetching = !list || list.fetching

  const { searchFilters } = useExperiencesSearchFilters()
  const validItemsLength = useMemo(() => list.ids.filter(id => !excludeIds?.includes(id)).length, [list, excludeIds])
  const tracking = useOfferListTracking(
    getListName('OfferList', 'EXPERIENCES', 'Experiences Page Offer List'),
    { key: list.placeId },
  )

  const ListComponent = isCompactTilesEnabled ? ExperienceDenseSearchList : ExperienceSearchList

  return (
    <VerticalSpacer gap={16}>
      <Heading variant="heading3">
        Our handpicked experiences{!!props.destinationName && props.destinationName !== 'Anywhere' && ` in ${props.destinationName}`}
      </Heading>
      <Group direction="horizontal" verticalAlign="center">
        {!fetching && list && <BodyText variant="large">{pluralizeToString('experience', validItemsLength)}</BodyText>}
        {fetching && <Loader inline />}
      </Group>
      <OfferListEventsProvider tracking={tracking}>
        <ListComponent
          placeId={list.placeId}
          sortBy={sortBy}
          categoryCodes={searchFilters.categoryCodes}
          priceGte={searchFilters.priceGte}
          priceLte={searchFilters.priceLte}
          luxPlusFeatures={searchFilters.luxPlusFeatures}
          excludeIds={excludeIds}
          collections={searchFilters.collections}
        />
      </OfferListEventsProvider>
    </VerticalSpacer>
  )
}

export default ExperienceSearchPageList
